<fieldset>
  <legend>
    TypeObjCPV
  </legend>
  <button (click)="addtypeCPVClass()" class="btn btn-outline-primary">Ajouter un typeCPVClass</button>
  <div *ngFor="let obj of typeObjCPV.objetComplementaire; let i = index">
    <fieldset>
      <legend>
        objetComplementaire {{ i + 1}}
      </legend>
      <button (click)="removetypeCPVClass(i)" class="btn btn-outline-primary">Supprimer un typeCPVClass</button>
      <app-typeCPV-class [parentForm]="parentForm" [typeCPVClass]="obj"
                         [uid]="getUid()+'_index_'+(i+1)"></app-typeCPV-class>
    </fieldset>
  </div>

  <fieldset>
    <legend>
      objetPrincipal
    </legend>
    <app-typeCPV-class [parentForm]="parentForm" [typeCPVClass]="typeObjCPV.objetPrincipal"
                       [uid]="getUid()"></app-typeCPV-class>
  </fieldset>
</fieldset>
